import Input from '@/shared/components/Inputs/Input';
import {FIELD, FIELD_LABEL, PLACEHOLDER} from '@/utils/constants';
import {Box} from '@mui/material';
import {Field, Formik} from 'formik';
import {FC, FocusEvent, useMemo} from 'react';
import {defaultInitialValues, IProfileGeneralForm, validationSchema} from './formConfiguration';
import {getErrorMessage, setRequiredLabel} from '@/utils/helpers';
import {profileFormStyle} from './ProfileFormStyle.styles';
import {IAdminInfo} from '@/utils/types/superAdmin.interface';
import {toast} from 'react-toastify';
import {useAppDispatch} from '@/store/hooks';
import {getSuperAdminInfo, updateSuperAdminProfile} from '@/store/admin';

const ProfileGeneralForm: FC<IProfileGeneralForm> = ({admin}) => {
	const dispatch = useAppDispatch();

	const formikInitialValues = useMemo(() => {
		const initialValues = admin
			? {
					name: admin.name,
					email: admin.email,
			  }
			: null;
		return initialValues || defaultInitialValues;
	}, [admin]);

	const handleProfileUpdate = async (event: FocusEvent<HTMLInputElement>, param: string) => {
		if (!admin) return;
		const params = {
			...admin,
			[param]: event.target.value,
		};

		try {
			if (admin[param as keyof IAdminInfo] === event.target.value) return;

			await dispatch(updateSuperAdminProfile(params)).unwrap();
			await dispatch(getSuperAdminInfo(admin.id)).unwrap();
		} catch (error) {
			toast.error(getErrorMessage(error));
		}
	};

	return (
		<Formik initialValues={formikInitialValues} validationSchema={validationSchema()} onSubmit={() => {}}>
			<Box sx={profileFormStyle.fieldContainer}>
				<Box sx={profileFormStyle.field}>
					<Field
						id={FIELD.name}
						name={FIELD.name}
						placeholder={PLACEHOLDER.adminName}
						label={setRequiredLabel(FIELD_LABEL.name)}
						component={Input}
						onBlur={(event: FocusEvent<HTMLInputElement>) => handleProfileUpdate(event, FIELD.name)}
					/>
				</Box>

				<Box sx={profileFormStyle.field}>
					<Field
						id={FIELD.email}
						name={FIELD.email}
						placeholder={PLACEHOLDER.email}
						label={setRequiredLabel(FIELD_LABEL.email)}
						component={Input}
						onBlur={(event: FocusEvent<HTMLInputElement>) => handleProfileUpdate(event, FIELD.email)}
					/>
				</Box>
			</Box>
		</Formik>
	);
};

export default ProfileGeneralForm;
